import {getInfo, login, loginCode, register, logout, updateForget} from '@/api/login'
import {getToken, removeToken, setToken} from '@/utils/auth'
import Cookies from 'js-cookie'
import tracker from '@/analytics/tracker.js'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    userInfo: '',
    userId: '',
    ccUser: '',
    ccSipPasswd: '',
    ccToken: '',
    ccRole: '',
    crmRole: Cookies.get('crmRole'),
    accessMenu: Cookies.get('accessMenu'),
    usrIdentity: Cookies.get('usrIdentity'),
    apiCompanyId: Cookies.get('apiCompanyId'),
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_CCUSER: (state, ccUser) => {
      state.ccUser = ccUser
    },
    SET_CCSIPPASSWD: (state, ccSipPasswd) => {
      state.ccSipPasswd = ccSipPasswd
    },
    SET_CCTOKEN: (state, ccToken) => {
      state.ccToken = ccToken
    },
    SET_CCROLE: (state, ccRole) => {
      state.ccRole = ccRole
    },
    SET_ACCESSMENU: (state, accessMenu) => {
      state.accessMenu = accessMenu
    },
    SET_CRMROLE: (state, crmRole) => {
      state.crmRole = crmRole
    },
    SET_USRIDENTITY: (state, usrIdentity) => {
      state.usrIdentity = usrIdentity
    },
    SET_APICOMPANYID: (state, apiCompanyId) => {
      state.apiCompanyId = apiCompanyId
    },
  },

  actions: {

    //注册
    Register({commit}, userInfo) {
      const fullName = userInfo.fullName.trim()
      const corporateName = userInfo.corporateName.trim()
      const phoneNo = userInfo.phoneNo.trim()
      const verificationCode = userInfo.verificationCode
      const source = new URLSearchParams(window.location.search).get('source')
      return new Promise((resolve, reject) => {
        register(fullName, corporateName, phoneNo, verificationCode, source).then(res => {
          setToken(res.data.accessToken);
          commit('SET_TOKEN', res.data.accessToken);
          commit('SET_USERID', res.data.userId);
          Cookies.set("userId", res.data.userId);
          Cookies.set("tenantId", res.data.tenantId);
          // 埋点：匿名访客ID → userId/tenantId 合并（注册即实名身份）
          tracker.identify(res.data.userId, { tenantId: res.data.tenantId })
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    //验证码登录
    LoginCode({commit}, userInfo) {
      const mobile = userInfo.phoneNo.trim()
      const code = userInfo.verificationCode
      const source = new URLSearchParams(window.location.search).get('source')
      return new Promise((resolve, reject) => {
        loginCode(mobile, code, source).then(res => {
          setToken(res.data.accessToken);
          commit('SET_TOKEN', res.data.accessToken);
          commit('SET_USERID', res.data.userId);
          commit('SET_CCUSER', res.data.callCenterUser.ccUser)
          commit('SET_CCSIPPASSWD', res.data.callCenterUser.ccSipPasswd)
          commit('SET_CCTOKEN', res.data.callCenterUser.ccToken)
          commit('SET_CCROLE', res.data.callCenterUser.ccRole)
          commit('SET_ACCESSMENU', res.data.accessMenu)
          commit('SET_CRMROLE', res.data.crmRole)
          commit('SET_USRIDENTITY', res.data.usrIdentity)
          commit('SET_APICOMPANYID', res.data.apiCompanyId)

          Cookies.set("userId", res.data.userId);
          Cookies.set("tenantId", res.data.tenantId);
          Cookies.set("ccUser", res.data.callCenterUser.ccUser);
          Cookies.set("ccSipPasswd", res.data.callCenterUser.ccSipPasswd);
          Cookies.set("ccToken", res.data.callCenterUser.ccToken);
          Cookies.set("ccRole", res.data.callCenterUser.ccRole);
          Cookies.set("accessMenu", res.data.accessMenu);
          Cookies.set("crmRole", res.data.crmRole);
          Cookies.set("usrIdentity", res.data.usrIdentity);
          Cookies.set("apiCompanyId", res.data.apiCompanyId);
          // 埋点：匿名访客ID → userId/tenantId 合并
          tracker.identify(res.data.userId, { tenantId: res.data.tenantId })
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    //密码登录
    Login({commit}, userInfo) {
      const phoneNo = userInfo.phoneNo.trim()
      const password = userInfo.password
      return new Promise((resolve, reject) => {
        login(phoneNo, password).then(res => {
          if (res.code == 0) {
            setToken(res.data.accessToken)
            commit('SET_TOKEN', res.data.accessToken)
            commit('SET_USERID', res.data.userId)
            commit('SET_CCUSER', res.data.callCenterUser.ccUser)
            commit('SET_CCSIPPASSWD', res.data.callCenterUser.ccSipPasswd)
            commit('SET_CCTOKEN', res.data.callCenterUser.ccToken)
            commit('SET_CCROLE', res.data.callCenterUser.ccRole)
            commit('SET_ACCESSMENU', res.data.accessMenu)
            commit('SET_CRMROLE', res.data.crmRole)
            commit('SET_USRIDENTITY', res.data.usrIdentity)
            commit('SET_APICOMPANYID', res.data.apiCompanyId)

            Cookies.set("userId", res.data.userId);
            Cookies.set("tenantId", res.data.tenantId);
            Cookies.set("ccUser", res.data.callCenterUser.ccUser);
            Cookies.set("ccSipPasswd", res.data.callCenterUser.ccSipPasswd);
            Cookies.set("ccToken", res.data.callCenterUser.ccToken);
            Cookies.set("ccRole", res.data.callCenterUser.ccRole);
            Cookies.set("accessMenu", res.data.accessMenu);
            Cookies.set("crmRole", res.data.crmRole);
            Cookies.set("usrIdentity", res.data.usrIdentity);
            Cookies.set("apiCompanyId", res.data.apiCompanyId);
            // 埋点：匿名访客ID → userId/tenantId 合并
            tracker.identify(res.data.userId, { tenantId: res.data.tenantId })
            resolve()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({commit, state}) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          if (res.code == 0) {
            const user = res.data
            const avatar = user.avatar;
            commit('SET_USERINFO', user)
            commit('SET_NAME', user.nickname)
            commit('SET_AVATAR', avatar)

            Cookies.set("userInfo", JSON.stringify(user));
            Cookies.set("name", user.nickname);
            Cookies.set("avatar", avatar);
            resolve(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({commit, state}) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_USERID', '')
          commit('SET_USERINFO', '')
          commit('SET_AVATAR', '')
          commit('SET_CCUSER', '')
          commit('SET_CCSIPPASSWD', '')
          commit('SET_CCTOKEN', '')
          commit('SET_CCROLE', '')
          commit('SET_ACCESSMENU', '')
          commit('SET_USRIDENTITY', '')
          commit('SET_APICOMPANYID', '')

          localStorage.removeItem('History')

          localStorage.removeItem('chatHistoryList')
          localStorage.removeItem('dialogueHistoryList')

          localStorage.removeItem('imageHistoryList')
          localStorage.removeItem('imageDialogueHistoryList')

          localStorage.removeItem('videoHistoryList')
          localStorage.removeItem('videoDialogueHistoryList')

          Cookies.remove("userInfo");
          Cookies.remove("userId");
          Cookies.remove("name");
          Cookies.remove("avatar");
          Cookies.remove('menuIndex');
          Cookies.remove("tenantId");
          Cookies.remove("ccUser");
          Cookies.remove("ccSipPasswd");
          Cookies.remove("ccToken");
          Cookies.remove("ccRole");
          Cookies.remove("accessMenu");
          Cookies.remove("usrIdentity");
          Cookies.remove("apiCompanyId");
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 修改密码
    UpdateForget({commit}, appMemberUserUpdatePasswordReqVO) {
      return new Promise((resolve, reject) => {
        updateForget(appMemberUserUpdatePasswordReqVO).then((res) => {
          if (res.code == 0) {
            commit('SET_TOKEN', '')
            commit('SET_USERID', '')
            commit('SET_USERINFO', '')
            commit('SET_AVATAR', '')
            commit('SET_CCUSER', '')
            commit('SET_CCSIPPASSWD', '')
            commit('SET_CCTOKEN', '')
            commit('SET_CCROLE', '')
            commit('SET_ACCESSMENU', '')
            commit('SET_USRIDENTITY', '')
            commit('SET_APICOMPANYID', '')
            removeToken()
            resolve(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js